import {
  Configuration,
  InteractionType,
  BrowserCacheLocation,
  LogLevel
} from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

/**
 * Configuração do MSAL para o projeto PREVI
 * Seguindo as premissas e arquitetura definidas
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: environment.CLIENT_ID,
    authority: `https://login.microsoftonline.com/${environment.TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin + '/login',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: () => undefined,
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Recursos protegidos do sistema PREVI
 */
export const protectedResources = {
  apiFinanciamento: {
    endpoint: 'https://api.previ.com.br',
    scopes: ['api://previ-financiamento/read', 'api://previ-financiamento/write'],
  },
  graphApi: {
    endpoint: 'https://graph.microsoft.com/v1.0/me',
    scopes: ['user.read']
  }
};

/**
 * Request padrão para login
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'offline_access', `api://${environment.CLIENT_ID}/API.Access`],
  prompt: 'select_account' as const,
};

/**
 * Scopes específicos para diferentes contextos
 */
export const previScopes = {
  default: ['openid', 'profile', 'email', 'offline_access', `api://${environment.CLIENT_ID}/API.Access`],
  api: [...protectedResources.apiFinanciamento.scopes],
  graph: [...protectedResources.graphApi.scopes],
};

/**
 * Configuração do Guard MSAL
 */
export const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: loginRequest,
  loginFailedRoute: '/acesso-negado',
};

/**
 * Configuração do Interceptor MSAL
 */
export const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap: new Map([
    [protectedResources.apiFinanciamento.endpoint, protectedResources.apiFinanciamento.scopes],
    [protectedResources.graphApi.endpoint, protectedResources.graphApi.scopes],
  ])
};
